import {List} from 'immutable';
import _ from 'underscore';

import * as HistoryBetActions from 'actions/HistoryBet';
import * as CouponRateActions from 'actions/CouponRate';
import * as MakeBetActions from 'actions/MakeBet';

import * as BetTypes from 'constants/BetType';
import * as StorageActions from 'actions/Storage';

export default function betTypesReducer(betTypes, betSlips, action) {
    switch (action.type) {
        case StorageActions.LOAD_STORAGE:
            const storedBetTypes = action.data.betTypes;
            if (storedBetTypes !== undefined && storedBetTypes !== null) {
                return new List(storedBetTypes);
            }
            break;

        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
            betTypes = fillBetTypes(betSlips, action.data);
            break;

        case HistoryBetActions.FAILURE_REQUEST_BET_TYPES:
        case CouponRateActions.REMOVE_COUPON_RATES:
        case MakeBetActions.FAILURE_MAKE_BET:
            //case MakeBetActions.MAKE_BET:
            return new List();

        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;
            let rateBlockNum = 0;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
                        rateBlockNum++;
                    }
                    if(createdBet.error === -18){
                        rateBlockNum++;
                    }
                }
            }

            return (rateBlockNum === 0) ? new List() : betTypes;
    }

    return betTypes;
}

function fillBetTypes(betSlips, data) {
    if (data.error) {
        return new List();
    }

    const betTypes = new List(data.betTypes);
    const antiExpressOdd = data.antiExpressOdd;

    let extendedBetTypes = new List();

    const ratesCount = betSlips.size;
    const rateValues = betSlips.valueSeq().map(bs => bs.getIn(['rate', 'value'])).toArray();

    for (let i = 0; i < betTypes.size; i++) {
        const betTypeId = betTypes.get(i);

        let odd = 0;
        switch (betTypeId) {
            case BetTypes.SINGLE:
                odd = _.reduce(rateValues, (sum, r) => sum + r, 0);

                extendedBetTypes = extendedBetTypes.push({
                    type: BetTypes.SINGLE,
                    odd
                });
                break;
            case BetTypes.EXPRESS:
                odd = _.reduce(rateValues, (prod, r) => prod * r, 1);

                extendedBetTypes = extendedBetTypes.push({
                    type: BetTypes.EXPRESS,
                    odd
                });
                break;
            case BetTypes.SYSTEM:
                for (let rank = 2; rank < ratesCount; rank++) {
                    odd = getSystemOdd(rateValues, rank);

                    extendedBetTypes = extendedBetTypes.push({
                        type: betTypeId,
                        rank,
                        count: ratesCount,
                        odd
                    });
                }
                break;
            /*case BetTypes.ANTIEXPRESS:
                extendedBetTypes = extendedBetTypes.push({
                    type: BetTypes.ANTIEXPRESS,
                    odd: antiExpressOdd
                });
                break;*/
        }
    }

    return extendedBetTypes;
}

function getSystemOdd(rates, rank) {
    function recursiveGetCombinations(rates, rank, index, tempArr, result) {
        for (let i = index; i < rates.length; i++) {
            ((index) => {
                const rateArr = tempArr.slice(0);
                rateArr.push(rates[index]);

                if (rank > 1) {
                    return recursiveGetCombinations(rates, rank - 1, index + 1, rateArr, result);
                } else {
                    result.push(rateArr);
                }
            })(i);
        }

        return result;
    }

    const tempArr = [];
    const resultArr = [];

    const combinations = recursiveGetCombinations(rates, rank, 0, tempArr, resultArr);

    let odd = 0;
    for (let i = 0; i < combinations.length; i++) {
        const combination = combinations[i];
        const expressOdd = _.reduce(combination, (prod, r) => prod * r, 1);
        odd = odd + expressOdd/combinations.length;
    }

    return odd;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/betTypesReducer.js